export default __webpack_public_path__ + "static/media/host_server.d8ef5611.svg";